import { Grid } from "@mui/material";
import { useFacultyListByDegreeQuery } from "api/faculty/faculty.mutation";
import { useFacultyGroupsListQuery } from "api/facultyGroups/facultyGroups.mutation";
import DatePickerField from "components/DatePickerField";
import { Button } from "components/LoadingButton";
import { Modal } from "components/Modal";
import RadioField from "components/RadioField";
import SelectField from "components/Select";
import SliderField from "components/SliderField";
import SwitchField from "components/SwitchField";
import TextField from "components/TextField";
import { countries } from "constants/countries";
import { APPLICATION_OPTIONS, DEGREE_OPTIONS, GENDER_OPTIONS } from "constants/options";
import { useEffect, useState } from "react";
import useStore from "store";
import classes from "./style.module.scss";

export const ApplicationFilterModal = ({
  open,
  onClose,
  control,
  reset,
  resetField,
  watch,
  reload,
  setReload,
}) => {
  const { userInfoStore } = useStore();

  const [fields, setFields] = useState([]);
  const facultiesQuery = useFacultyListByDegreeQuery();
  const facultyGroupsQuery = useFacultyGroupsListQuery({ page: 1, page_size: 150 });
  const faculties = facultiesQuery.data ?? [];
  const groups = facultyGroupsQuery.data?.results ?? [];

  const handleCloseModal = () => {
    onClose();
  };
  const handleSubmitForm = () => {
    setReload(!reload);
    handleCloseModal();
  };
  const handleResetForm = () => {
    reset({
      age_min: 0,
      age_max: 80,
      university_status: "",
      faculty_status: "",
      country: "",
      degree: "",
      faculty: "",
      field_of_study: "",
      group: "",
      agent: "",
      eamil: "",
      gender: "",
      create_at_after: "",
      create_at_before: "",
      tracking_id: "",
      search: "",
      more_than_one_request: false,
    });
    handleSubmitForm();
  };
  useEffect(() => {
    resetField("faculty");
  }, [watch("degree")]);
  useEffect(() => {
    resetField("field_of_study");
    const facultyFields = faculties?.[watch("degree")]?.find(
      (faculty) => faculty.id === watch("faculty")
    );
    if (facultyFields) {
      setFields(facultyFields.fields_of_studies);
    }
  }, [watch("faculty")]);

  return (
    <Modal
      open={open}
      title="فیلتر"
      onClose={handleCloseModal}
      maxWidth="lg"
      footerEnd={
        <>
          <Button
            size="large"
            variant="contained"
            onClick={handleSubmitForm}
            className={classes.submitFilterButton}
          >
            اعمال فیلتر
          </Button>
          <Button
            size="large"
            variant="contained"
            className={classes.resetFilterButton}
            onClick={handleResetForm}
          >
            پاک کردن فیلتر
          </Button>
        </>
      }
    >
      <div className={classes.mainForm}>
        <Grid container direction="row" spacing={3}>
          <Grid item xs={12} sm={6} md={3}>
            <DatePickerField
              theme={2}
              variant="filled"
              label="از تاریخ"
              name="create_at_after"
              control={control}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <DatePickerField
              theme={2}
              variant="filled"
              label="تا تاریخ"
              name="create_at_before"
              control={control}
              maxDate={new Date()}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <SelectField
              theme={2}
              variant="filled"
              label="مقطع"
              name="degree"
              control={control}
              options={DEGREE_OPTIONS}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <SelectField
              theme={2}
              variant="filled"
              label="دانشکده"
              name="faculty"
              control={control}
              disabled={!watch("degree")}
              options={faculties?.[watch("degree")]?.map((faculty) => {
                return {
                  value: faculty.id,
                  label: faculty.fa_name,
                };
              })}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <SelectField
              theme={2}
              variant="filled"
              label="رشته"
              name="field_of_study"
              control={control}
              disabled={!watch("faculty")}
              options={fields?.map((field) => {
                return {
                  value: field.id,
                  label: field.fa_name,
                };
              })}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <SelectField
              theme={2}
              variant="filled"
              label="گروه"
              name="group"
              control={control}
              options={groups?.map((group) => {
                return {
                  value: group.id,
                  label: group.name,
                };
              })}
            />
          </Grid>
          {userInfoStore?.is_superuser ? (
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                theme={2}
                variant="filled"
                label="ایمیل ایجنت"
                type="text"
                name="agent"
                control={control}
              />
            </Grid>
          ) : (
            <></>
          )}
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              theme={2}
              variant="filled"
              label="ایمیل اپلیکنت"
              type="text"
              name="email"
              control={control}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <SelectField
              theme={2}
              variant="filled"
              label="کشور"
              name="country"
              control={control}
              options={countries}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <SelectField
              theme={2}
              variant="filled"
              label="وضعیت درخواست"
              name="university_status"
              control={control}
              options={APPLICATION_OPTIONS}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              theme={2}
              variant="filled"
              label="کد رهگیری"
              type="text"
              name="tracking_id"
              control={control}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              theme={2}
              variant="filled"
              label="نام و نام خانوادگی"
              type="text"
              name="search"
              control={control}
            />
          </Grid>
          <Grid
            item
            xs={0}
            sm={userInfoStore?.is_superuser ? 6 : 0}
            md={userInfoStore?.is_superuser ? 3 : 6}
          />
          <Grid container className={classes.filterData}>
            <Grid item xs={12} sm={6} md={3}>
              <RadioField
                label="جنسیت"
                name="gender"
                options={GENDER_OPTIONS}
                row
                theme={2}
                control={control}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} className={classes.filteredItem}>
              <SliderField
                label="بازه سنی"
                minName="age_min"
                maxName="age_max"
                control={control}
                min={0}
                max={80}
                step={1}
                valueLabelDisplay="auto"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <SwitchField
                label="تنها نمایش دانشجوهای با بیش از یک درخواست"
                name="more_than_one_request"
                control={control}
              />
            </Grid>
          </Grid>
        </Grid>
      </div>
    </Modal>
  );
};
